import React from "react";
import Header from "./components/header";
import NavBar from "./components/navbar";
import Footer from "./components/footer";
import "./App.css";

function App() {
  return (
    <div className="d-flex flex-column min-vh-100 bg-darkest">
      <Header />
      <NavBar />
      <Footer />
    </div>
  );
}

export default App;
